const ProductData = [
    {
        id: 0,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
    {
        id: 1,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
        ]
    },
    {
        id: 2,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
        ]
    },
    {
        id: 3,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
    {
        id: 4,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
        ]
    },
    {
        id: 5,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
    {
        id: 6,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
    {
        id: 7,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
    {
        id: 8,
        title: 'حجر جرانيت ذهبي',
        price: '١٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
    {
        id: 9,
        title: 'حجر ذهبي',
        price: '٨٩٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
    {
        id: 10,
        title: 'حجر جرانيت ذهبي',
        price: '٤٦٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
        ]
    },
    {
        id: 11,
        title: 'حجر جرانيت ذهبي',
        price: '٦٨٠٠',
        realPrice: 1800,
        image: require('../../Assets/granite-pro.jpg'),
        type: 'granite',
        country: 'السعودية',
        colors: [
            {
                id: 0,
                name: 'ابيض بلوري'
            }
        ],
        paragraph: "جرانيت سعودي مميز بلونه الأبيض البلوري الصافي بدون عروق، مع حبيبات متوسطة الحجم على سطحه. ويعرف بسعره الرخيص وكمياته المتوفرة دائمًا. يمكن استخدامه في بلاط الأرضيات، والجدران والأسطح وعتبات النوافذ.",
        details: [
            {
                id: 0,
                name: 'صناعة سعودية'
            },
            {
                id: 1,
                name: 'جودة و مواصفات عالية'
            },
            {
                id: 2,
                name: "مقاومة الماء و الرطوبة"
            },
            {
                id: 3,
                name: "سهولة التنظيف"
            }
        ]
    },
]

export default ProductData;